import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.scss";

const Header: React.FC = () => {
  const location = useLocation();

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-brand">
          <Link to="/" className="brand-link">
            <span className="brand-note">♪</span>
            <span className="brand-insta">Insta</span>
            <span className="brand-music">MusicTools</span>
          </Link>
        </div>
        <nav className="header-nav">
          <Link
            to="/about"
            className={`nav-link ${location.pathname === "/about" ? "active" : ""}`}
          >
            About
          </Link>
          <Link
            to="/instakeys"
            className={`nav-link ${location.pathname === "/instakeys" ? "active" : ""}`}
          >
            Piano Video Tool
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
